export enum STATE {
  WINNER,
  ONGOING,
  TIED
}

export const PLAYER_X = "X";
export const PLAYER_O = "O";
